/**
 * Builds the breadcrumb trail for a catalog product from its publicData:
 *   Home › <Category> › <Subcategory> › <title>
 * Category and subcategory link into the search page's category /
 * subcategory filters. Subcategory labels are derived from the stored enum
 * value (drop the category suffix, underscores → spaces), so no hard-coded
 * list of ~100 subcategory names has to be kept in sync here.
 */

export const CATEGORY_LABELS = {
  Fresh_Flowers: 'Flowers',
  Edible_Bouquets: 'Edible Bouquets',
  Baked_Goods: 'Baked Goods',
  Candy_Sweets: 'Candy & Sweets',
  Balloons: 'Balloons',
  Gourmet_Sets: 'Gourmet Sets',
  Custom_Gifts: 'Custom Gifts',
  Gift_Sets: 'Gift Sets',
  Home_Decor: 'Home Decor',
  Indoor_Plants: 'Indoor Plants',
  Beauty: 'Beauty',
  Tea_Coffee: 'Tea & Coffee',
  Party_Decor: 'Decor',
  Tableware: 'Tableware',
};

// The publicData field that carries each category's subcategory value.
const SUBFIELD_BY_CATEGORY = {
  Fresh_Flowers: 'Flower_Categories',
  Edible_Bouquets: 'Bouquet_Categories',
  Baked_Goods: 'Bakery_Categories',
  Candy_Sweets: 'Candy_Categories',
  Balloons: 'Balloon_Designs',
  Gourmet_Sets: 'Gourmet_Sets_Categories',
  Indoor_Plants: 'Plant_Categories',
  Party_Decor: 'Party_Collections',
  Beauty: 'Beauty_Categories',
  Tea_Coffee: 'Tea_Coffee_Categories',
  Home_Decor: 'Decor_Categories',
  Custom_Gifts: 'Gift_Categories',
  Gift_Sets: 'Gift_Categories',
};

const subcategoryLabel = (value, categoryId) =>
  String(value || '')
    .replace(new RegExp(`_?${categoryId}$`), '')
    .replace(/_/g, ' ')
    .trim();

export const buildCatalogBreadcrumbs = (publicData, title) => {
  const crumbs = [{ label: 'Home', href: '/' }];
  const categoryId = publicData?.categoryLevel1;
  if (categoryId && CATEGORY_LABELS[categoryId]) {
    crumbs.push({
      label: CATEGORY_LABELS[categoryId],
      href: `/s?pub_categoryLevel1=${categoryId}`,
    });
    const subField = SUBFIELD_BY_CATEGORY[categoryId];
    const subValue = subField ? publicData[subField] : null;
    if (subValue) {
      crumbs.push({
        label: subcategoryLabel(subValue, categoryId),
        href: `/s?pub_categoryLevel1=${categoryId}&pub_${subField}=${subValue}`,
      });
    }
  }
  if (title) crumbs.push({ label: title, href: null });
  return crumbs;
};

// Human label for a category key ("Gourmet_Sets" -> "Gourmet Sets").
export const categoryLabel = key => CATEGORY_LABELS[key] || String(key || '').replace(/_/g, ' ');
